<template>
  <!-- drawer judge point add -->
  <el-drawer
    :title="editorText + '二级指标'"
    :visible.sync="dialogVisible"
    custom-class="zyyj-dialog"
    direction="rtl"
    :show-close="false"
    @open="handleOpen"
  >
    <el-form label-width="120px" :rules="rules" ref="form" :model="form">
      <el-row>
        <el-col :span="24">
          <el-form-item label="指标名称" prop="name">
            <el-input v-model.trim="form.name" :maxlength="10" placeholder="请输入指标名称"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="评价要点" prop="point">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 9}"
              v-model.trim="form.point"
              :maxlength="200"
              placeholder="不超过200字"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="drawer-footer">
      <el-button size="small" @click="closeDialog">取 消</el-button>
      <el-button size="small" type="primary" :disabled="submitting" @click="submitForm('form')">确 定</el-button>
    </div>
  </el-drawer>
</template>

<script>
// import _ from 'lodash'
// import __ from '@/util/common-utils'
export default {
  props: ['identify', 'visible'],
  data () {
    return {
      rules: {
        name: [
          { required: true, message: '指标名称不得为空', trigger: 'blur' },
          { min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur' }
        ],
        point: [
          { required: true, message: '评价要点不得为空', trigger: 'blur' },
          { min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur' }
        ]
      },
      submitting: false,
      form: { id: null, name: '', point: '' },
      isLastSuccessful: false
    }
  },
  computed: {
    dialogVisible: {
      get () { return this.visible === true },
      set () { this.$emit('update:visible', false) }
    },
    editing () { return this.identify && this.identify.id > 0 },
    editorText () { return this.identify && this.identify.id ? '编辑' : '添加' }
  },
  mounted () {

  },
  methods: {
    handleOpen () {
      this.$refs.form && this.$refs.form.resetFields()
      this.submitting = false
      this.form.name = this.identify.name || ''
      this.form.point = this.identify.pointsContent || ''
    },

    closeDialog () {
      if (this.isLastSuccessful) {
        this.$emit('edit-result', true)
      }
      this.$emit('update:visible', false)
    },

    xhrUpdate () {
      let realFormData = {
        id: this.identify.id,
        name: this.form.name,
        pointsContent: this.form.point,
        primaryIndicatorId: this.identify.primaryIndicatorId
      }
      this.$xhrPut(`/eval/indicators/secondary`, realFormData).then(rs => {
        if (!rs) {
          this.submitting = false
        }
        if (rs.code === 'SUCCESS') {
          this.$message.success('操作成功')
          this.isLastSuccessful = true
          this.closeDialog()
        } else {
          this.submitting = false
        }
      })
    },

    xhrAdd () {
      let realFormData = {
        name: this.form.name,
        pointsContent: this.form.point,
        primaryIndicatorId: this.identify.primaryIndicatorId
      }
      this.$xhrPost(`/eval/indicators/secondary`, realFormData).then(rs => {
        if (!rs) {
          this.submitting = false
        }
        if (rs.code === 'SUCCESS') {
          this.$message.success('操作成功')
          this.isLastSuccessful = true
          this.closeDialog()
        } else {
          this.submitting = false
        }
      })
    },

    submitForm (formName) {
      this.submitting = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.editing ? this.xhrUpdate() : this.xhrAdd()
        } else {
          this.$message.error('请检查输入')
          this.submitting = false
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/common/AddSecondStandard.vue